import { composeIO } from 'react-compose-io'
import { regularizacaoCiclosInformacoesIO } from './RegularizacaoCiclosInformacoes.IO'
import { RegularizacaoCiclosInformacoesView } from './RegularizacaoCiclosInformacoesView'

export const RegularizacaoCiclosInformacoes = composeIO(RegularizacaoCiclosInformacoesView, regularizacaoCiclosInformacoesIO)
